<template>
  <div class="visit" data-testid="visit-detail">
    <div class="row">
      <div class="col-md-12">
        <div class="card" v-if="visit">
          <div class="card-header d-flex justify-content-between" data-testid="visit-header">
            <div class="col-sm-6">
              <template v-if="visit.type === 'normal'">
                Návštěva {{ visit.date }} ({{ visit.timeFrom }} - {{ visit.timeTo }}): <span class="font-weight-bold">{{ visit.visit_purpose.purpose }}</span>
              </template>
              <template v-else-if="visit.type === 'task'">
                Úkol {{ visit.date }}: <span class="font-weight-bold">{{ visit.visit_purpose.purpose }}</span>
              </template>
              <template v-if="editingVisitId === visit.id "><label for="note">poznámka: </label>
              <form class="form-inline" @submit.prevent="putVisit(visit)">
                <input v-model="editingVisit.note" type="text" class="form-control ml-sm-1 col-sm-10 mr-sm-2" aria-describedby="noteHelp" id="note" data-testid="visit-note-input">
                <button v-if="!waitForSave" type="submit" class="btn btn-primary" data-testid="visit-note-save">Uložit</button>
                <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
              </form>
            </template>
              <template v-else=""><button @click="editVisit(visit.note, visit.id)" class="btn btn-sm btn-link text-secondary" data-testid="visit-note-edit"><i class="fa fa-pencil" aria-hidden="true"></i></button><i>poznámka: {{ visit.note }}</i></template>
            </div>
            <div class="col-sm-6 text-right">
              {{ visit.state | stateToCS }}
              <button v-if="visit.state !== 'failed' && visit.state !== 'excused' && visit.state !== 'completed' && visit.state !== 'canceled'" class="btn btn-sm btn-success" @click="completeVisit" data-testid="visit-complete"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> dokončit návštěvu</button>
            </div>
          </div>
          <div class="card-header justify-content-between">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'VisitMedicalReport'}" v-if="$route.name !== 'VisitMedicalReport'" data-testid="visit-tab-medical-report"><i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i> Lékařská zpráva</router-link>
                <span class="nav-link active" v-else data-testid="visit-tab-medical-report"><i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i> Lékařská zpráva</span>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'VisitDiagnosis'}" v-if="$route.name !== 'VisitDiagnosis'" data-testid="visit-tab-diagnosis"><i class="fa fa-stethoscope fa-lg" aria-hidden="true"></i> Diagnózy a výkony</router-link>
                <span class="nav-link active" v-else data-testid="visit-tab-diagnosis"><i class="fa fa-stethoscope fa-lg" aria-hidden="true"></i> Diagnózy a výkony</span>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'VisitMedicament'}" v-if="$route.name !== 'VisitMedicament'" data-testid="visit-tab-medicament"><i class="fa fa-adjust fa-lg" aria-hidden="true"></i> Léky a recepty</router-link>
                <span class="nav-link active" v-else><i class="fa fa-adjust fa-lg" aria-hidden="true"></i> Léky a recepty</span>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'VisitVoucher'}" v-if="$route.name !== 'VisitVoucher'" data-testid="visit-tab-voucher"><i class="fa fa-crutch fa-lg" aria-hidden="true"></i> Poukazy</router-link>
                <span class="nav-link active" v-else data-testid="visit-tab-voucher"><i class="fa fa-crutch fa-lg" aria-hidden="true"></i> Poukazy</span>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'VisitDocument'}" v-if="$route.name !== 'VisitDocument'" data-testid="visit-tab-document"><i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> Dokumenty</router-link>
                <span class="nav-link active" v-else data-testid="visit-tab-document"><i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> Dokumenty</span>
              </li>
            </ul>
          </div>
          <router-view></router-view>
        </div>
        <div class="text-center" v-else-if="visitPending">
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
          (načítám)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        update_visit: {
          state: ''
        },
        changeStatePending: false,
        changeStateError: false,
        // VISIT
        visit: false,
        visitPending: false,
        visitError: false,
        editingVisitId: false,
        editingVisit: {},
        waitForSave: false
      }
    },
    mixins: [apiMixin],
    watch: {
      visit (val) {
        this.$store.commit('setClientId', val.client.id)
      },
      '$route.params.visitid' () {
        this.getVisit(this.$route.params.visitid)
      }
    },
    components: {
      // ClientVisits,
    },
    methods: {
      editVisit (note, id) {
        this.editingVisitId = id
        this.editingVisit = {
          note: note
        }
      },
      putVisit () {
        this.waitForSave = true
        this.$http.put('visit/' + this.editingVisitId, this.editingVisit, {emulateJSON: true}).then(response => {
          this.waitForSave = false
          this.editingVisitId = false
          this.editingVisit = {}
          this.getVisit(this.$route.params.visitid)
        }, response => {
          this.errors = response.data.errors
          this.waitForSave = false
        })
      },
      completeVisit () {
        this.changeStatePending = true
        this.update_visit.state = 'completed'
        if (this.visit.type === 'normal') {
          this.$http.put('visit/' + this.$route.params.visitid, this.update_visit, {emulateJSON: true}).then(response => {
            this.submited = response.data
            this.changeStatePending = false
            this.$router.push({name: 'Home'})
          }).catch(error => {
            this.changeStateError = error.response.data.errors
            this.changeStatePending = false
          })
        } else if (this.visit.type === 'task') {
          this.$http.put('visit_task/' + this.$route.params.visitid, this.update_visit, {emulateJSON: true}).then(response => {
            this.submited = response.data
            this.changeStatePending = false
            this.$router.push({name: 'Home'})
          }).catch(error => {
            this.changeStateError = error.response.data.errors
            this.changeStatePending = false
          })
        }
      }
    },
    beforeMount () {
      this.getVisit(this.$route.params.visitid)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.input-group.input-group-unstyled input.form-control {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.input-group-unstyled .input-group-addon {
  border-radius: 4px;
  border: 0px;
  background-color: transparent;
}
.row_description {
}
.row_description > td {
  padding-bottom: 1px;
  border: none;
  font-size: smaller;
}
.row_data {
}
.row_data > td {
  padding-top: 0px;
  font-weight: bold;
  font-size: large;
  border: none;
}

.width_fix {
  width: 100%;
}
.label_like {
  max-width: 100%;
  /*font-weight: bold;*/
}
.main_attribute {
  max-width: 100%;
  font-size: x-large;
  font-weight: bold;
}

.custom_panel_heading {
  border-bottom: none;
  padding-bottom: 0;
  background-color: #b5e3cf;
}

.custom_panel_heading .nav-tabs {
  border-bottom: none;
}

.custom_panel_heading .nav-tabs > li > a {
  background-color: #fff;
}

.custom_panel_heading .nav-tabs > li:nth-child(odd) {
  margin-right: 0;
}

.custom_panel_heading .nav-tabs > li:nth-child(even) {
  margin-left: 0;
}

.hidden {
  display: none !important;
  visibility: hidden !important;
}

</style>



// WEBPACK FOOTER //
// src/views/Visit/ShowVisit.vue?6e90006c